/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UserSolutionListResponse,
  UtxSolutionGetSolutionListParams
} from './schema'



export const utxSolutionGetSolutionList = (
    params?: UtxSolutionGetSolutionListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserSolutionListResponse>> => {
    return axios.get(
      `/solutions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSolutionGetSolutionListQueryKey = (params?: UtxSolutionGetSolutionListParams,) => [`/solutions`, ...(params ? [params]: [])];

    
export type UtxSolutionGetSolutionListQueryResult = NonNullable<Awaited<ReturnType<typeof utxSolutionGetSolutionList>>>
export type UtxSolutionGetSolutionListQueryError = AxiosError<unknown>

export const useUtxSolutionGetSolutionList = <TData = Awaited<ReturnType<typeof utxSolutionGetSolutionList>>, TError = AxiosError<unknown>>(
 params?: UtxSolutionGetSolutionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSolutionGetSolutionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSolutionGetSolutionListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSolutionGetSolutionList>>> = ({ signal }) => utxSolutionGetSolutionList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSolutionGetSolutionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

